export default `
fragment ParagraphForm on ParagraphForm {
  uuid
  entityBundle
}
`